module.exports = __webpack_public_path__ + "media/src/assets/images/sale-ai_graph1-bc168b182c99699cccf637967e572353.png";